import React from "react";

const Project = ({ projects, openLightbox }) => {
  return (
    <div>
      {projects.map((project, index) => (
        <div key={index} className="px-lg-5 py-3 pb-4 row mx-lg-3">
          {index % 2 === 0 ? (
            <div
              className="col-lg-6 px-0 project_img rounded"
              //   style={{ height: "280px", overflow: "hidden" }}
            >
              <img
                onClick={() => openLightbox(project.id)}
                alt="example"
                class="rounded hoverable"
                src={project.front_image}
              />
            </div>
          ) : null}
          <div
            className={`${
              index % 2 === 0 ? "text-right" : "text-left"
            } col-lg-6 p-2 project-content`}
          >
            <p className="font-medium font-weight-bolder project-tag">
              Featured Project
            </p>
            <h5 className="font-weight-bold project_title">{project.name}</h5>
            <div className="rounded mt-3 left-aligned-box">
              <p className="p-4 hoverable font-medium font-weight-bolder project-description">
                {project.description}
              </p>
            </div>
            <ul
              className={`${
                index % 2 === 0
                  ? "justify-content-lg-end"
                  : "justify-content-lg-start"
              } d-flex font-weight-bolder p-0 justify-content-center`}
              //   style={{ justifyContent: "flex-start" }}
              type="none"
            >
              {project.technologies.map((tech, index) => (
                <li key={index + tech} className="px-2">
                  {tech}
                </li>
              ))}
            </ul>
            <div className="project-links">
              <a
                href={project.git_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  class="fab fa-github pr-4"
                  style={{ fontSize: "large" }}
                  aria-hidden="true"
                ></i>
              </a>
              <a
                href={project.web_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  class="fas fa-external-link-alt"
                  style={{ fontSize: "large" }}
                  aria-hidden="true"
                ></i>
              </a>
            </div>
          </div>
          {index % 2 !== 0 ? (
            <div
              className="col-lg-6 px-0 project_img rounded"
              //   style={{ height: "280px", overflow: "hidden" }}
            >
              <img
                onClick={() => openLightbox(project.id)}
                alt="example"
                class="rounded hoverable"
                src={project.front_image}
              />
            </div>
          ) : null}
          <br />
        </div>
      ))}
    </div>
  );
};

export default Project;
